"use strict";

var _classCallCheck = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/createClass");

var _possibleConstructorReturn = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/possibleConstructorReturn");

var _getPrototypeOf = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/getPrototypeOf");

var _inherits = require("/usr/src/app/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/inherits");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var DateParser_1 = require("../../core/model/data-dictionary/parsers/DateParser");

var StructPropBuilder_1 = require("../../core/model/data-dictionary/StructPropBuilder");

var EntityStateFlag_1 = require("../../core/model/EntityStateFlag");

var FlagSet_1 = require("../../core/model/FlagSet");

var StateDomainObject_1 = require("../../core/model/StateDomainObject");
/**
 * @author Adam Drda
 */


var Baseline =
/*#__PURE__*/
function (_StateDomainObject_1$) {
  _inherits(Baseline, _StateDomainObject_1$);

  /**
   * @param id the internal id
   * @param externalId
   * @param productId the internal id of product
   * @param siteId the internal site id
   * @param date
   * @param amount
   * @param stateFlags
   */
  function Baseline(id, externalId, productId, siteId, date, amount, stateFlags) {
    var _this;

    _classCallCheck(this, Baseline);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(Baseline).call(this, stateFlags));
    _this.id = id;
    _this.externalId = externalId;
    _this.productId = productId;
    _this.siteId = siteId;
    _this.date = date;
    _this.amount = amount;
    _this.stateFlags = stateFlags;
    return _this;
  }

  _createClass(Baseline, null, [{
    key: "fromMat",
    value: function fromMat(mat) {
      return new Baseline(mat.id, mat.externalId, mat.productId, mat.siteId, mat.date, mat.amount, mat.stateFlags);
    }
  }]);

  return Baseline;
}(StateDomainObject_1.StateDomainObject);

exports.Baseline = Baseline;
Baseline.EMPTY_FLAG_SET = FlagSet_1.FlagSet.of(EntityStateFlag_1.EntityStateFlag);

Baseline.schema = function () {
  var builder = new StructPropBuilder_1.StructPropBuilder(Baseline.name);
  return {
    id: builder.id('id'),
    externalId: builder.str('externalId'),
    productId: builder.str('productId'),
    siteId: builder.str('siteId'),
    date: builder.date('date', DateParser_1.DateParser.ISO_PATTERN),
    amount: builder.num('amount'),
    stateFlags: builder.flags('stateFlags', EntityStateFlag_1.EntityStateFlag)
  };
}();